export default "__VITE_PUBLIC_ASSET__837aa294__"